/**
 * Fusionne le state persisté local avec les constantes INIT_* :
 * pour chaque entité d’init, garde la version persistée si présente, sinon l’init ;
 * conserve les entités utilisateur absentes de l’init (ids non listés).
 * Utilisé en hydrate hors Supabase pour réinjecter pack/abo/programme si une vieille sauvegarde n’en avait que 4.
 *
 * Reset des entités legacy (ids non-UUID) : `useAppStore.hydrate` vide clients/events/products
 * si `_schemaVersion < PERSIST_SCHEMA_VERSION` (voir `constants/persistSchema.js`).
 */

function byIdMap(arr, idKey = "id") {
  const m = new Map();
  for (const x of Array.isArray(arr) ? arr : []) {
    m.set(String(x[idKey]), x);
  }
  return m;
}

export function mergePersistedClientsWithInit(persisted, initClients) {
  const pMap = byIdMap(persisted);
  const initIds = new Set((initClients || []).map((c) => String(c.id)));
  const merged = (initClients || []).map((ic) => pMap.get(String(ic.id)) ?? ic);
  for (const [id, c] of pMap) {
    if (!initIds.has(id)) merged.push(c);
  }
  return merged;
}

export function mergePersistedEventsWithInit(persisted, initEvents) {
  const pMap = byIdMap(persisted);
  const initIds = new Set((initEvents || []).map((e) => String(e.id)));
  const merged = (initEvents || []).map((ie) => pMap.get(String(ie.id)) ?? ie);
  for (const [id, e] of pMap) {
    if (!initIds.has(id)) merged.push(e);
  }
  return merged;
}

export function mergePersistedProductsWithInit(persisted, initProducts) {
  const pMap = byIdMap(persisted);
  const initIds = new Set((initProducts || []).map((p) => String(p.id)));
  const merged = (initProducts || []).map((ip) => pMap.get(String(ip.id)) ?? ip);
  for (const [id, p] of pMap) {
    if (!initIds.has(id)) merged.push(p);
  }
  return merged;
}
